import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import CloseIcon from '@material-ui/icons/Close';

import Intro from './Intro';
import Missions, { MissionDialog, MissionSuccessDialog } from './Missions';
import { closeHelp, closeMissions, startMission } from 'store/actions/help';
import { startEditAdmin } from 'store/actions/admin';

// root: {
//   top: 0,
//   left: 0,
//   right: 0,
//   bottom: 0,
//   zIndex: theme.zIndex.overlay,
//   position: 'fixed',
//   backgroundColor: 'rgba(0, 0, 0, 0.5)',
//   transition:'.5s ease-in-out'
// },
//
// width: '100vw',
// height: '100vh',
const styles = theme =>({
  root: {
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    zIndex: theme.zIndex.overlay,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    transition:'.5s ease-in-out'
  },
  inactive: {
    width: "0px",
    height: "0px",
  },
  closeButton: {
    position: 'fixed',
    top: 5,
    right: 100,
    zIndex: theme.zIndex.overlay + 1,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*4,
  }
});

const Help = (props) => {
  const {
    classes,
    help,
    closeHelp,
  } = props;
  const currentMission = help.currentMission;
  const showOverlay = help.showHelp || help.currentMission.inProgress;
  const currentStep = currentMission.steps[currentMission.currentStep];
  const success = currentStep && currentStep.success;
  //const success = true;
  //<div className={help.showHelp showOverlay ? classes.root : classes.inactive}>
  //<div className={help.showHelp ? classes.root : classes.inactive}>
  return(
    <div id="overlay" className={showOverlay ? classes.root : classes.inactive}>
      <Intro />
      <Missions />
      <MissionDialog acceptMission={help.acceptMission} />
      <MissionSuccessDialog show={success} />
      {showOverlay &&
        <Button
          className={classes.closeButton}
          variant="fab"
          aria-label="close"
          onClick={() => closeHelp()}
        >
          <CloseIcon />
        </Button>
      }
    </div>
  );
}

const mapStateToProps = (state) => ({
  help: state.help,
});

const mapDispatchToProps = {
  closeHelp,
  closeMissions,
  startMission,
  startEditAdmin,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(Help);



// WEBPACK FOOTER //
// ./src/components/admin/Help/Help.jsx